import { MapTo } from "@adobe/aem-react-editable-components";
import { CallToAction } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const callToActionEditConfig = {
    emptyLabel: "CallToAction",
    isEmpty: (props) => {
        if (!props.title || !props.background || !props.mobileBackground || !props.ctaUrl || !props.ctaTitle) {
            return true;
        }
        if (props.restrictedContent &&
            (!props.restrictedTitle || !props.restrictedDescription || !props.ctaRestrictedTitle || !props.ctaRestrictedUrl))
            return true;
        return false;
    },
    getProps: (props) => ({
        variant: props.variant,
        title: props.title,
        titleLoggedIn: props.titleLoggedIn,
        text: props.text,
        background: props.background,
        description: props.description,
        mobileBackground: props.mobileBackground,
        headerPosition: props.headerPosition,
        theme: props.theme,
        buttonImage: props.buttonImage,
        buttonPosition: props.buttonPosition,
        ctaTitle: props.ctaTitle,
        ctaUrl: props.ctaUrl,
        secondaryCtaTitle: props.secondaryCtaTitle,
        secondaryCtaUrl: props.secondaryCtaUrl,
        ctaTitleLoggedIn: props.ctaTitleLoggedIn,
        ctaUrlLoggedIn: props.ctaUrlLoggedIn,
        secondaryCtaTitleLoggedIn: props.secondaryCtaTitleLoggedIn,
        secondaryCtaUrlLoggedIn: props.secondaryCtaUrlLoggedIn,
        animatedBackground: props.animatedBackground,
        withGradient: props.withGradient,
        animatedButton: props.animatedButton,
        animatedLabel: props.animatedLabel,
        restrictedContent: props.restrictedContent,
        restrictedTitle: props.restrictedTitle,
        restrictedDescription: props.restrictedDescription,
        ctaRestrictedTitle: props.ctaRestrictedTitle,
        ctaRestrictedUrl: props.ctaRestrictedUrl,
        secondaryCtaRestrictedTitle: props.secondaryCtaRestrictedTitle,
        secondaryCtaRestrictedUrl: props.secondaryCtaRestrictedUrl,
        ctaHeightAuto: props.ctaHeightAuto,
    }),
};
export default MapTo("loyalty/components/calltoaction")(withAemAuthoring(CallToAction, callToActionEditConfig));
